import { ButtonPosition, ALL_BUTTON_POSITION_LIST, } from '@/common/manager/position/button-position';
import { getRealizeValue } from '@/common/util/util';
export const config = {
    value: 'jsAction',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, _context, position, extraParams = {}, formInstance, field, recordDataSource, jsParamList = [], } = config;
        const { name, options } = buttonConfig;
        const { jsFunction } = options || {};
        if (typeof jsFunction === 'function') {
            if ([
                ButtonPosition.filterItemEvent,
                ButtonPosition.formItemEvent,
                ButtonPosition.formDialogItemEvent,
            ].includes(position)) {
                if (name === 'onChange') {
                    const { formValue, fieldName } = extraParams;
                    const value = '';
                    return jsFunction(value, fieldName, formValue, _context);
                }
                else {
                    return jsFunction(field, getRealizeValue(formInstance));
                }
            }
            else if ([
                ButtonPosition.form,
                ButtonPosition.formDialog,
                ButtonPosition.formEvent,
            ].includes(position)) {
                const form = getRealizeValue(formInstance);
                const state = _context?.state;
                async function executeJsFunction() {
                    return await jsFunction({ state, form });
                }
                return executeJsFunction();
            }
            else if ([ButtonPosition.tabEvent].includes(position)) {
                const state = _context?.state;
                async function executeJsFunction() {
                    await jsFunction(recordDataSource, state);
                }
                return executeJsFunction();
            }
            else if ([ButtonPosition.entryPointEvent].includes(position)) {
                async function executeJsFunction() {
                    await jsFunction(recordDataSource);
                }
                return executeJsFunction();
            }
            else {
                async function executeJsFunction() {
                    await jsFunction(...jsParamList);
                }
                return executeJsFunction();
            }
        }
    },
};
